module.exports = __webpack_public_path__ + "krecove-zily_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_2_before.jpg
// module id = 1028
// module chunks = 0